import { render, staticRenderFns } from "./page9.vue?vue&type=template&id=793b23e2"
import script from "./page9.vue?vue&type=script&lang=js"
export * from "./page9.vue?vue&type=script&lang=js"
import style0 from "./page9.vue?vue&type=style&index=0&id=793b23e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports